/* Product media gallery for the bd-advertorial section.
   Videos autoplay muted on loop and cannot be stopped, so all this does is
   drive the mobile carousel arrows. */

function bdMediaStep(track) {
  var item = track.querySelector('.bd-advertorial__media-item');

  if (!item) return track.clientWidth;

  var styles = window.getComputedStyle(track);
  var gap = parseFloat(styles.columnGap || styles.gap) || 0;

  return item.getBoundingClientRect().width + gap;
}

function bdMediaUpdateArrows(gallery) {
  var track = gallery.querySelector('[data-bd-media-track]');
  var prev = gallery.querySelector('[data-bd-media-prev]');
  var next = gallery.querySelector('[data-bd-media-next]');

  if (!track) return;

  var max = track.scrollWidth - track.clientWidth;
  var scrollable = max > 1;

  if (prev) prev.classList.toggle('is-hidden', !scrollable || track.scrollLeft <= 1);
  if (next) next.classList.toggle('is-hidden', !scrollable || track.scrollLeft >= max - 1);
}

function bdMediaBindGallery(gallery) {
  var track = gallery.querySelector('[data-bd-media-track]');
  var prev = gallery.querySelector('[data-bd-media-prev]');
  var next = gallery.querySelector('[data-bd-media-next]');

  if (!track) return;

  if (prev) {
    prev.addEventListener('click', function () {
      track.scrollBy({ left: -bdMediaStep(track), behavior: 'smooth' });
    });
  }

  if (next) {
    next.addEventListener('click', function () {
      track.scrollBy({ left: bdMediaStep(track), behavior: 'smooth' });
    });
  }

  track.addEventListener('scroll', function () {
    bdMediaUpdateArrows(gallery);
  }, { passive: true });

  window.addEventListener('resize', function () {
    bdMediaUpdateArrows(gallery);
  });

  window.addEventListener('load', function () {
    bdMediaUpdateArrows(gallery);
  });

  bdMediaUpdateArrows(gallery);
}

function bdMediaInit() {
  var galleries = document.querySelectorAll('[data-bd-media]');

  for (var i = 0; i < galleries.length; i++) {
    bdMediaBindGallery(galleries[i]);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bdMediaInit);
} else {
  bdMediaInit();
}
